// Is AI reachable by anyone in this workspace?
//
// The interface answers this per user — `ai.enabled` for everyone, or the
// caller's id in `ai.enabledTo` (interface `_agent-mcp.functions.js`, mirrored
// client-side by its `useIsAiEnabled` composable). The console has no single
// user in hand when it renders a workspace-level switch, so the question it can
// answer is the workspace-level one: could ANY user pass that gate.
//
// ADVISORY, AND IT FAILS OPEN. The interface asks more of a user than this can
// see: an eligible role (admin/creator/editor), not blocked, and `validUntil`
// still in the future. A workspace whose `enabledTo` holds only deprovisioned or
// expired users therefore reads as OPEN here while the interface refuses every
// one of them. Answering that properly needs per-user expiry and role in the
// tenant-user projection, which is the eligibility preview this deliberately
// leaves out. Never treat a `true` from here as permission — the endpoint's own
// refusal and the interface's per-user checks are the answers that bind.
//
// It matters for MCP specifically. MCP eligibility is `ai.mcpEnabled` AND the
// AI gate, so with AI shut the MCP switch writes a field nothing acts on — a
// setting that reads "on" while MCP stays closed. That is what this predicate
// exists to warn about.
//
// `enabled === true` rather than a truthiness test, because that is how the
// interface reads it. A legacy `'true'` string would otherwise open the gate
// here and stay shut there — the console would show no warning for a workspace
// where MCP could never work.
export const isAiGateOpen = (ai) => ai?.enabled === true || Boolean(ai?.enabledTo?.length);
